import { Select } from "antd";
import { ReplaceUnderscoreWithSpace } from "../../Utils/Utils";
import { useEffect } from "react";
import "../../GlobalCss/SPF/AdjustmentsComponents.css"
const DynamicColumns = ({ dynamicColumns = { DefaultHeaders: [], EADCodes: [] }, setSelectedColumns, selectedColumns, dataSource }) => {
    const BuildDataSourceHeaders = async () => {

        let TotalHeaders = [];
        dataSource.forEach(eachRecord => {
          Object.keys(eachRecord).map(key => TotalHeaders.push(key));
        });
        TotalHeaders = [...new Set(TotalHeaders)];
    
        let SelectDefaultHeaders = [];
        TotalHeaders.forEach(eachHeader => {
          if (dynamicColumns.EADCodes.includes(eachHeader)) {
            SelectDefaultHeaders.push(eachHeader);
          };
        });
        let Headers = SelectDefaultHeaders.map((item, index) => ({
          key: item,
          value: item,
          children: ReplaceUnderscoreWithSpace(item)
        }))
        setSelectedColumns(Headers);
      }
    
      useEffect(()=>{
        BuildDataSourceHeaders();
      },[dataSource]);
    return (
        <>
            <Select
                mode="multiple"
                maxTagCount="responsive"
                allowClear
                className="dynamic-column-selection-ead"
                placeholder={<span className="grey-placeholder">Select Columns</span>}
                onChange={(selectedLables, selectedObjects)=>setSelectedColumns(selectedObjects)}
                value={selectedColumns}
            >
                {
                    dynamicColumns.EADCodes.map((column, index) => (
                        <Select.Option key={column} value={column}>
                            {ReplaceUnderscoreWithSpace(column)}
                        </Select.Option>
                    ))
                }
            </Select>
        </>
    )
}
export default DynamicColumns;